import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Contracts/Main.vue";
import Signin from "../views/Signin.vue";
import Users from "@/views/Users.vue";
import ContractDefinitionFields from "@/views/ContractDefinitionFields.vue";
import Companies from "../views/Companies.vue";
import CompanyOfficials from "../views/CompanyOfficials.vue";
import definitionRoles from "../views/Definitions/DefitinionsRoles.vue";
import CompanyCategories from "../views/Definitions/CompanyCategories.vue";
import personal from "../views/Definitions/Personal.vue";
import OsgbBranch from "../views/OsgbBranch.vue";
import CompaniesDetails from "../views/CompaniesDetails.vue";
import ContractDetails from "../views/Contracts/ContractDetails.vue";
import SeniorityCeiling from "../views/Definitions/SeniorityCeiling.vue";
import ActiveContractPage from "../views/ActiveContractPage.vue";
import PassiveContractPage from "../views/PassiveContractPage.vue";
import OccupationalSafetyExpertsPage from "../views/OccupationalSafetyExpertsPage.vue";
import WorkplacePhysicianPage from "../views/WorkplacePhysicianPage.vue";
import OtherHealthPersonnelPage from "../views/OtherHealthPersonnelPage.vue";
import OccupationalSafetyExpertsAPage from "../views/OccupationalSafetyExpertsAPage.vue";
import OccupationalSafetyExpertsBPage from "../views/OccupationalSafetyExpertsBPage.vue";
import OccupationalSafetyExpertsCPage from "../views/OccupationalSafetyExpertsCPage.vue";
import SGKCeiling from "../views/Definitions/SGKCeiling.vue";
import SGKRate from "../views/Definitions/SGKRate.vue";
import CompanyManagementExpense from "../views/Definitions/CompanyManagementExpense.vue";
import PersonalFieldsComponent from "../views/Contracts/PersonalFieldsComponent.vue";
import PersonalDetails from "../views/Definitions/PersonalDetails.vue";
import MonthlyOsgbSalesAmount from "@/views/Definitions/MonthlyOsgbSalesAmount.vue";


const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/active-contracts",
    name: "ActiveContractPage",
    component: ActiveContractPage,
    meta: { requiresAuth: true }
  },
  {
    path: "/passive-contracts",
    name: "PassiveContractPage",
    component: PassiveContractPage,
    meta: { requiresAuth: true }
  },
  {
    path: "/occupational-safety-experts-page",
    name: "OccupationalSafetyExpertsPage",
    component: OccupationalSafetyExpertsPage,
    meta: { requiresAuth: true }
  },
  {
    path: "/occupational-safety-experts-a-page",
    name: "OccupationalSafetyExpertsAPage",
    component: OccupationalSafetyExpertsAPage,
    meta: { requiresAuth: true }
  },
  {
    path: "/occupational-safety-experts-b-page",
    name: "OccupationalSafetyExpertsBPage",
    component: OccupationalSafetyExpertsBPage,
    meta: { requiresAuth: true }
  },
  {
    path: "/occupational-safety-experts-c-page",
    name: "OccupationalSafetyExpertsCPage",
    component: OccupationalSafetyExpertsCPage,
    meta: { requiresAuth: true }
  },
  {
    path: "/workplace-physician-page",
    name: "WorkplacePhysicianPage",
    component: WorkplacePhysicianPage,
    meta: { requiresAuth: true }
  },
  {
    path: "/other-health-personnel-page",
    name: "OtherHealthPersonnelPage",
    component: OtherHealthPersonnelPage,
    meta: { requiresAuth: true }
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
    meta: { requiresAuth: true }
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { requiresAuth: true }
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
    meta: { requiresAuth: true }
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
    meta: { requiresAuth: true }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/users",
    name: "users",
    component: Users
  },
  {
    path: "/companies",
    name: "companies",
    component: Companies
  },
  {
    path: '/personal/:id',
    name: 'PersonalDetails',
    component: PersonalDetails
  },
  {
    path: '/companies/:id',
    name: 'companiesDetails',
    component: CompaniesDetails
  },
  {
    path: '/companies/:id',
    name: 'contractDetails',
    component: ContractDetails
  },
  {
    path: '/seniority-burden',
    name: 'SeniorityCelling',
    component: SeniorityCeiling
  },
  {
    path: '/sgk-ceiling',
    name: 'SGKCeiling',
    component: SGKCeiling
  },
  {
    path: '/sgk-rate',
    name: 'SGKRate',
    component: SGKRate
  },
  {
    path: '/company-management-expense',
    name: 'CompanyManagementExpense',
    component: CompanyManagementExpense
  },
  {
    path: '/monthly-osgb-sales-amount',
    name: 'MonthlyOsgbSalesAmount',
    component: MonthlyOsgbSalesAmount
  },
  {
    path: '/personal/:contractId',
    name: 'personal',
    component: PersonalFieldsComponent,
    props: true
  },
  {
    path: "/company-officials",
    name: "companyOfficials",
    component: CompanyOfficials
  },
  {
    path: "/osgb-branch",
    name: "osgbBranch",
    component: OsgbBranch
  },
  {
    path: "/definitions-contract-fields",
    name: "definitionContractFields",
    component: ContractDefinitionFields
  },
  {
    path: "/definitions-roles",
    name: "definitionRoles",
    component: definitionRoles
  },
  {
    path: "/definitions-company-categories",
    name: "companyCategories",
    component: CompanyCategories
  },
  {
    path: "/definitions-personal",
    name: "personal",
    component: personal
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});


router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('jwtToken');

  // Eğer Signin sayfasına gidiyorsa ve zaten authenticated ise Dashboard'a yönlendir
  if (to.name === 'Signin' && isAuthenticated) {
    next({ name: 'Dashboard' });
    return;
  }

  // Eğer sayfa authentication gerektiriyorsa ve kullanıcı authenticated değilse Signin'e yönlendir
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'Signin' });
    return;
  }

  // Diğer durumlarda normal devam et
  next();
});

export default router;
